import { CircularProgress, Stack } from "@mui/joy";

export function Loading() {
    return <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        height="100%"
    ><CircularProgress /></Stack>
}